import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const getCartProductsApi = (id) =>
    Promise.resolve(axios.get(endpoints.getCartProducts.replace("{id}", id)));
